import { render, staticRenderFns } from "./TabSpecialHours.vue?vue&type=template&id=db45e018&scoped=true&"
import script from "./TabSpecialHours.vue?vue&type=script&lang=js&"
export * from "./TabSpecialHours.vue?vue&type=script&lang=js&"
import style0 from "./TabSpecialHours.vue?vue&type=style&index=0&id=db45e018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db45e018",
  null
  
)

export default component.exports